import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() => matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = matchMedia(query);

    const handleChange = (ev: MediaQueryListEvent) => setMatches(ev.matches);

    mediaQueryList.addEventListener('change', handleChange);

    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};
